/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type onboardingState_state$data = {
  readonly key: string;
  readonly value: string | null;
  readonly " $fragmentType": "onboardingState_state";
};
export type onboardingState_state$key = {
  readonly " $data"?: onboardingState_state$data;
  readonly " $fragmentSpreads": FragmentRefs<"onboardingState_state">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "onboardingState_state",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "OnboardingState"
};

(node as any).hash = "4458ec6e78736741d79615a29b68de83";

export default node;
